export default __webpack_public_path__ + "static/media/pec_logo.25001c6f.jpg";